import { render, staticRenderFns } from "./Mfa.vue?vue&type=template&id=619485b2&scoped=true&"
import script from "./Mfa.vue?vue&type=script&lang=js&"
export * from "./Mfa.vue?vue&type=script&lang=js&"
import style0 from "./Mfa.vue?vue&type=style&index=0&id=619485b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619485b2",
  null
  
)

export default component.exports